import { Mapper } from 'src/base/mapper'
import { ClientDataTableTypeEntity } from 'src/data/entities/client.entity'
import { ClientDataTableTypeModel } from 'src/domain/models/client.model'

export class ClientDataTableMapper extends Mapper<ClientDataTableTypeEntity, ClientDataTableTypeModel> {
	mapFrom(param: ClientDataTableTypeEntity): ClientDataTableTypeModel {
		return {
			clientId: param.clientId,
			productId: param.productId,
			companyName: param.companyName,
		}
	}

	mapTo(param: ClientDataTableTypeModel): ClientDataTableTypeEntity {
		return {
			clientId: param.clientId,
			productId: param.productId,
			companyName: param.companyName,
			tenantId: null,
			accountType: null,
			industryId: null,
			fristName: null,
			lastName: null,
			taxId: null,
			email: null,
			phone: null,
			mobile: null,
			isActive: null,
			url: null,
			productName: null,
			subscriptionStatusId: null,
			subscriptionType: null,
		}
	}
}
